import { IToolbarConfig } from '@wangeditor/editor'

export type RichTextEditorProps = {
  onChange?: (value: string) => void
  value?: string
  minHeight?: number
  readOnly?: boolean
  placeholder?: string
  autoFocus?: boolean
  useFullScreen?: boolean
  insertKeys?: IToolbarConfig['insertKeys']
  excludeKeys?: IToolbarConfig['excludeKeys']
  onEditorBlur?: React.FocusEventHandler<HTMLDivElement>
  onBlur?: () => void
  styles?: React.CSSProperties
}

export type RichTextEditorRef = {
  getPlainText?: () => string | undefined
}

export type InsertFnType = (url: string, alt: string, href: string) => void

// 对齐的 svg
export const justifySvg =
  '<svg viewBox="0 0 1024 1024"><path d="M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>'

// 缩进的 svg
export const indentSvg =
  '<svg viewBox="0 0 1024 1024"><path d="M0 64h1024v128H0z m384 192h640v128H384z m0 192h640v128H384z m0 192h640v128H384zM0 832h1024v128H0z m0-128V320l256 192z"></path></svg>'

export const uploadSvg =
  '<svg viewBox="0 0 48 48"><path d="M11 8v32h26V19h-8a3 3 0 0 1-3-3V8H11Zm19 2.828V15h4.172L30 10.828ZM7 7a3 3 0 0 1 3-3h18.828L41 16.172V41a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3V7Z"/></svg>'
